// @copyright  2006-2023 West Indies Software Engineering Company Limited. All rights reserved.
import taxBillPayments from './tax-bill-payments.js';

export default [
    {
        path: '/:organisation/tax-compliance/tax-bills',
        component: () =>
            import('@/pages/[organisation]/tax-compliance/tax-bills.vue'),
        name: 'tax-compliance.tax-bills.search-tax-bills',
        meta: {
            loginRequired: true,
            permission: 'access.tax-compliance.view-tax-bills',
        },

        children: [
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/tax-compliance/tax-bills/[id].vue'),
                name: 'tax-compliance.tax-bills.view-tax-bill',
                meta: {
                    loginRequired: true,
                    permission: 'access.tax-compliance.view-tax-bills',
                },
            },
            ...taxBillPayments,
        ],
    },
];
